import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@pxl/models/contracts';
import { map } from 'rxjs/operators';

export const cultureResolver: ResolveFn<string> = () => {
    return inject(UserService)
        .getUser()
        .pipe(map((user) => user.culture));
};
